import { Box, Link } from '@chakra-ui/react';
import React from 'react';

export default function SpannedText({ children, isUrl = false, url = '' }) {
    let urlText = {};

    if (isUrl) {
        urlText = {
            as: Link,
            href: url,
            target: '_blank',
            rel: 'noopener noreferrer',
        };
    }

    return (
        <Box display={'inline'} color={'info.500'} fontWeight={'700'} {...urlText}>
            {children}
        </Box>
    );
}
